import axiosInstance from 'api/axiosInstance';

export const deleteComment = async (commentID: number): Promise<void> => {
	try {
		const response = await axiosInstance.get(
			`/api/cantrackv3/DeleteComment?id=${commentID}`,
		);

		if (response.status !== 200) {
			throw new Error(`Error deleting: Status ${response.status}`);
		}

		return;
	} catch (error) {
		console.error('delete error:', error);
		throw error;
	}
};
